import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'cfe-country-select-confirmation',
	templateUrl: './country-select-confirmation-dialog.component.html',
	styleUrls: ['./country-select-confirmation-dialog.component.scss']
})
export class CountrySelectConfirmationDialogComponent implements OnInit {
	countDeselected: number;
	countSelected: number;

	constructor(protected activeModal: NgbActiveModal) {}

	ngOnInit(): void {}

	decline(): void {
		this.activeModal.close();
	}

	confirm(): void {
		this.activeModal.close(true);
	}
}
